import { createFileRoute } from "@tanstack/react-router";

import { ForgotPasswordPage } from "../features/auth/ForgotPasswordPage";

// Outside the signed-out layout: the code signs the person in before the new password is saved.
export const Route = createFileRoute("/forgot-password")({ component: ForgotPasswordPage });
